import { render, staticRenderFns } from "./viewpatientpack.vue?vue&type=template&id=a0bf88a8&scoped=true&"
import script from "./viewpatientpack.vue?vue&type=script&lang=js&"
export * from "./viewpatientpack.vue?vue&type=script&lang=js&"
import style0 from "./viewpatientpack.vue?vue&type=style&index=0&id=a0bf88a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0bf88a8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1209661745/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a0bf88a8')) {
      api.createRecord('a0bf88a8', component.options)
    } else {
      api.reload('a0bf88a8', component.options)
    }
    module.hot.accept("./viewpatientpack.vue?vue&type=template&id=a0bf88a8&scoped=true&", function () {
      api.rerender('a0bf88a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ViewPackages/viewpatientpack.vue"
export default component.exports